module.exports = __webpack_public_path__ + "img/outdoors4G.79f2cd4d.jpg";